import React from 'react';
import { useTranslation } from 'react-i18next';
import avgPaywallImg from '@/assets/images/journals/avg-paywall-mobile.webp';
import chartPaywallImg from '@/assets/images/journals/chart-paywall-mobile.webp';
import piePaywallImg from '@/assets/images/journals/pie-paywall-mobile.webp';
import { JournalMobilePaywallCard } from '@/pages/Overview/JournalMobilePaywallCard';

export const JournalMobilePaywall: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col gap-9 pt-3">
      <section className="flex flex-col gap-4">
        <h2 className="text-title-24 text-foreground">
          {t('overview.journals.grades')}
        </h2>
        <div className="flex flex-col gap-3">
          <JournalMobilePaywallCard
            description={t('overview.journals.paywall.gradesDescription')}
            image={chartPaywallImg}
            imageClassName="mr-[15px] w-[105px]"
          />
          <JournalMobilePaywallCard
            description={t('overview.journals.paywall.averageDescription')}
            image={avgPaywallImg}
            imageClassName="mr-[15px] w-[86px]"
          />
        </div>
      </section>

      <section className="flex flex-col gap-4">
        <h2 className="text-title-24 text-foreground">
          {t('overview.tabs.attendance')}
        </h2>
        <JournalMobilePaywallCard
          description={t('overview.journals.paywall.attendanceDescription')}
          image={piePaywallImg}
          imageClassName="w-[81px]"
        />
      </section>
    </div>
  );
};
